import {
  BlockAccessPointDto,
  BlockAccessPointsApi,
  CreateBlockAccessPointRequest,
  UpdateBlockAccessPointRequest,
} from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'

class BlockAccessPointsService {
  private readonly client = createApiClient(BlockAccessPointsApi)

  async create(request: CreateBlockAccessPointRequest): Promise<BlockAccessPointDto[]> {
    const { data } = await this.client.create(request)
    return data.ids.map((id, index) => ({
      id,
      side: request.side,
      minBay: request.items[index].minBay ?? null,
      maxBay: request.items[index].maxBay ?? null,
      minRow: request.items[index].minRow ?? null,
      maxRow: request.items[index].maxRow ?? null,
    }))
  }

  async update(request: UpdateBlockAccessPointRequest): Promise<void> {
    await this.client.update(request)
  }

  async delete(id: string): Promise<void> {
    await this.client._delete({ id })
  }
}

export const blockAccessPointsService = new BlockAccessPointsService()
